import React from "react";
import { Link } from "react-router";

import { Button } from "../Controls";

import "./styles.less";

const PageActions = () => (
  <div className="page-actions">
    <Button accent={true} large={true}>
      <Link to="/contact">Contact us</Link>
    </Button>
    <Button primary={true} large={true}>
      <Link to="/">Back to homepage</Link>
    </Button>
  </div>
);

export default PageActions;



// WEBPACK FOOTER //
// ./components/Pages/PageActions.js